(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laven-customer-gifs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('laven-gifs-slider')) {
    class LavenGifsSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-slider-viewport]');
        this.slides = Array.from(this.querySelectorAll('.laven-gifs__item'));
        this.prevButton = this.querySelector('[data-slider-prev]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
        this.currentIndex = 0;

        this.onResize = this.debounce(() => this.setup(), 120);
        this.onScroll = this.debounce(() => this.updateCurrentIndex(), 80);

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);

        this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sliderDot)));
        });

        requestAnimationFrame(() => {
          this.setup();
          this.playVideos();
          this.updateDots();
        });
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.viewport?.removeEventListener('scroll', this.onScroll);
      }

      setup() {
        if (!this.viewport || !this.slides.length) return;

        const viewportWidth = this.viewport.clientWidth;
        if (!viewportWidth) return;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        const desktopColumns = Math.max(
          1,
          Number.parseInt(
            getComputedStyle(this).getPropertyValue('--gifs-desktop-columns'),
            10
          ) || 3
        );

        const mobileWidthPercent = Math.max(
          50,
          Number.parseFloat(
            getComputedStyle(this).getPropertyValue('--gifs-mobile-width')
          ) || 78
        );

        const gap = isMobile ? 14 : 20;

        const baseCardWidth = isMobile
          ? viewportWidth * (mobileWidthPercent / 100)
          : (viewportWidth - gap * (desktopColumns - 1)) / desktopColumns;

        const cardWidth = baseCardWidth * 0.8;
        this.style.setProperty('--gifs-card-width', `${cardWidth}px`);
      }

      goTo(index) {
        if (!this.slides.length) return;

        const normalizedIndex =
          (index + this.slides.length) % this.slides.length;

        this.currentIndex = normalizedIndex;
        this.updateDots();

        this.slides[normalizedIndex].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      updateCurrentIndex() {
        if (!this.viewport || !this.slides.length) return;

        const viewportRect = this.viewport.getBoundingClientRect();
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const distance = Math.abs(viewportRect.right - slideRect.right);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;
        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.currentIndex);
        });
      }

      playVideos() {
        this.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.playsInline = true;

          const promise = video.play();
          promise?.catch?.(() => {});
        });
      }

      debounce(callback, wait) {
        let timeout;

        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => callback.apply(this, args), wait);
        };
      }
    }

    customElements.define('laven-gifs-slider', LavenGifsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laven-journey-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('laven-journey-tabs')) {
    class LavenJourneyTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.activate(button.dataset.tabTarget));
        });

        if (window.Shopify && Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            this.activate(event.target.dataset.tabPanel);
          });
        }

        const activeButton = this.buttons.find((button) => button.classList.contains('is-active'));
        if (activeButton) {
          this.activate(activeButton.dataset.tabTarget);
        }
      }

      activate(id) {
        this.buttons.forEach((button) => {
          const active = button.dataset.tabTarget === id;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const active = panel.dataset.tabPanel === id;
          const video = panel.querySelector('video');

          panel.classList.toggle('is-active', active);
          panel.hidden = !active;

          if (video) {
            video.muted = true;
            video.playsInline = true;

            if (active) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            } else {
              video.pause();
            }
          }
        });
      }
    }

    customElements.define('laven-journey-tabs', LavenJourneyTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
